// extracted by mini-css-extract-plugin
module.exports = {"iconLeft":"styles_iconLeft__rX4JW","iconRight":"styles_iconRight__3DFZZ","iconUp":"styles_iconUp__YPgC8","iconDown":"styles_iconDown__uvx5X"};